import React, { useEffect, useState } from 'react';
import '../../newArrival/style/img.css';
import './style/ImgComp.css';
import AllItem from '../../newArrival/AllItem';
import { useLocation } from 'react-router-dom';
import Banner from '../Banner/Banner';
import FastFilter from '../SideFilters/FastFilter';
import productDetails from '../../../json/product.json';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack'; 
import SetLoader from '../../loader/SetLoader';

const ImgComp = ({ setOpenAccordions, selectedFilters,setSelectedFilters, handleChangeFilter, filter }) => {

    const allProductData = productDetails?.newPrd;
    const location = useLocation();
    const searchParams1 = new URLSearchParams(location.search);
    const prdid = searchParams1.get("prdcategory");

    const itemsPerPage = 16; 
    const [currentPage, setCurrentPage] = useState(1);
    const [productFilterItems, setProductFilterItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        setLoading(true); 
        const data = allProductData.filter((item) => {
            const categoryMatch = selectedFilters.category.length === 0 || selectedFilters.category.includes(item.prdcategory);
            const colorMatch = selectedFilters.jewelryColor.length === 0 || selectedFilters.jewelryColor.includes(item.jwelleryColour);
            const materialMatch = selectedFilters.jewelryMaterial.length === 0 || selectedFilters.jewelryMaterial.includes(item.jwelleryMaterial);
            const diamondTypeMatch = selectedFilters.diamondType.length === 0 || selectedFilters.diamondType.includes(item.diamondType);
            const caratMatch = selectedFilters.jewelryCarat.length === 0 || selectedFilters.jewelryCarat.includes(item.jwelleryCarats);
            return categoryMatch && colorMatch && materialMatch && diamondTypeMatch && caratMatch;
        });
        setLoading(false);
        setProductFilterItems(data);
    }, [selectedFilters, allProductData]);

    useEffect(() => {
        setLoading(true); 
        if (prdid) {
            const prdData = allProductData.filter((x) => x?.categoryId?.toString() === prdid);
            setProductFilterItems(prdData);
            setTimeout(() => {
                setLoading(false); 
            }, 2000);
        } else if (filteredItems.length > 0) {
            setProductFilterItems(filteredItems);
            setTimeout(() => {
                setLoading(false); 
            }, 2000);
        } else {
            setProductFilterItems(allProductData);
            setTimeout(() => {
                setLoading(false); 
            }, 2000);
        }
        
    }, [prdid, allProductData, filteredItems]);

    const totalPages = Math.ceil(productFilterItems.length / itemsPerPage);

    const handleChangePage = (event, value) => {
        setLoading(true); 
        setCurrentPage(value);
        const courseContainer = document.querySelector("#allProductFilter");
        if (courseContainer){
            courseContainer.scrollIntoView({ behavior: "smooth"});
        }
        // window.scrollTo({
        //     top: 0,
        //     behavior: "smooth"
        // });
        setTimeout(() => {
            setLoading(false); 
        }, 1500);
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = productFilterItems.slice(startIndex, endIndex);

    return (
        <div className="sm:m:1" style={{ width: '100%' }} >
            <div>
                <Banner />
            </div>
            <div  id='allProductFilter'>
                <FastFilter selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} filter={filter} setFilteredItems={setFilteredItems} setOpenAccordions={setOpenAccordions} />
            </div>
            <div>
            {loading ? (
                <div className="flex justify-center items-center" >
                    <SetLoader />
                </div>
            ) : (
                <>
                    <div className='card-set flex-wrap gap-5  'style={{width:'100%'  }}>
                        {
                            currentItems?.map((x, i) => (
                                <AllItem key={i} id={x.id} prdimg={x.prdimg} prdname={x.prdname} prdprice={x.prdprice} rating={x.rating} jwelleryMaterial={x.jwelleryMaterial} diamondType={x.diamondType} item={x} />
                            ))
                        }
                    </div>
                    <div className="flex items-center gap-8 justify-center mt-5">
                        <Stack spacing={2}>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handleChangePage}
                                shape="rounded"
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        color: 'black',
                                    }
                                }}
                            />
                        </Stack>
                    </div>
                </>
            )}
            </div>
        </div>
    );
};

export default ImgComp;


